export const changeFormatNumbersCardsSummary = (num) => {
  let newNumberFormat = 0
  let splitNumberThousand = String(Math.abs(num))?.split('.')

  if (splitNumberThousand[0].length >= 7) {
    newNumberFormat = convertToMillionFormat(num)
  }

  if (splitNumberThousand[0].length < 7) {
    newNumberFormat = String(parseFloat(num).toLocaleString('en'))
    let newNumberFormatSplit = String(Math.abs(newNumberFormat))?.split('.')

    if (newNumberFormatSplit[1]?.length === 2) {
      newNumberFormat = `${newNumberFormat}0`
    }
  }

  return newNumberFormat
}

export const changeFormatNumbersGraphics = (num) => {
  let newNumberFormat = 0

  newNumberFormat = parseFloat(num).toLocaleString('en')

  return newNumberFormat
}

const convertToMillionFormat = (millions) => {
  let newMillionFormat = String(parseFloat(millions).toLocaleString('en'))
  let splitMillions = newMillionFormat?.split(',')
  let newNumberFormat = `${splitMillions[0]}.${splitMillions[1]}M`

  return newNumberFormat
}
